export default __webpack_public_path__ + "static/media/-W_8XJnvUD7dzB2Cy_gIZ2MuUZctdhow.4a472d2a.woff2";